import styled from 'styled-components';
var Overlay = styled.div.withConfig({
  displayName: "Overlay",
  componentId: "sc-1cvjayg-0"
})(["position:fixed;background-color:", ";top:0;right:0;bottom:0;left:0;z-index:9;touch-action:none;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.overlay;
});
export default Overlay;